import { render, staticRenderFns } from "./PasswordRequest.vue?vue&type=template&id=96ebe1fe&scoped=true&"
import script from "./PasswordRequest.vue?vue&type=script&lang=js&"
export * from "./PasswordRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ebe1fe",
  null
  
)

export default component.exports